<h2 mat-dialog-title class="modal-add-header">
  <mat-icon class="with-text" color="white">lock</mat-icon>เปลี่ยนรหัสผ่าน
</h2>
<form [formGroup]="fg" (ngSubmit)="changePassword()" #form>
  <mat-dialog-content>

    <mat-form-field>
      <mat-label>รหัสผ่านที่ใช้ในปัจจุบัน</mat-label>
      <input matInput type="password" placeholder="รหัสผ่านที่ใช้ในปัจจุบัน" formControlName="currentPassword">
      <mat-error *ngIf="fg.get('currentPassword').getError('required')">{{ _e.changePasswordInputOldPassword }}</mat-error>
      <mat-error *ngIf="fg.get('currentPassword').getError('wrongPassword')">{{ _e.changePasswordWrongOldPassword }}</mat-error>
    </mat-form-field>
    <br>
    <mat-divider></mat-divider>
    <br>
    <div formGroupName="pwd">
      <mat-form-field>
        <mat-label>รหัสผ่าน</mat-label>
        <input type="password" formControlName="password" matInput placeholder="รหัสผ่าน">
        <mat-error *ngIf="pFG.get('password').getError('required')">{{ _e.addUserRequiredPassword }}</mat-error>
        <mat-error *ngIf="pFG.get('password').getError('minlength')">{{ _e.addUserPasswordLength }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>รหัสผ่านอีกครั้ง</mat-label>
        <input 
            type="password" formControlName="confirmPassword" 
            matInput placeholder="รหัสผ่านอีกครั้ง" [errorStateMatcher]="passwordMatcher">
            <mat-error *ngIf="pFG.get('confirmPassword').getError('required')">{{ _e.addUserRequiredPassword }}</mat-error>    
            <mat-error *ngIf="pFG.hasError('identity') && pFG.get('confirmPassword').valid">{{ _e.addUserPasswordConfirm }}</mat-error>
      </mat-form-field>
    </div>
    <mat-divider></mat-divider>
    <mat-error *ngIf="authenFailed"> {{ resultFalseMessage }} <br></mat-error>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="flex-spacer"></div>
    <button type="button" mat-raised-button mat-dialog-close [mat-dialog-close]="true">ยกเลิก</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-raised-button class="submit-button">บันทึก</button>
  </mat-dialog-actions>
</form>